import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" InReview ")
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_timer = _resolveComponent("timer")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.state.orders,
      lazy: _ctx.state.isLoading,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "createdAt",
          label: "Create"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_timer)
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.moment(scope.row.createdAt).format('YYYY-MM-DD HH:mm')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "orderName",
          label: "Name"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.orderDetail(scope.row._id)),
              class: "text-primary"
            }, _toDisplayString(scope.row.orderName), 9, _hoisted_1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "storeName",
          label: "Customer"
        }),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "Fulfillment Status"
        }, {
          default: _withCtx((scope) => [
            (scope.row.status === 'Unfulfilled')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_el_tag, {
                    type: "primary",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.status), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true),
            (scope.row.status === 'In Review')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_el_tag, {
                    type: "primary",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (scope.row.status === 'Hold')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_el_tag, {
                    type: "warning",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.status), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true),
            (scope.row.status === 'Fulfilled' ||
            scope.row.status === 'Partially Fulfilled' ||
            scope.row.status === 'Approved'
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_el_tag, {
                    type: "success",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.status), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true),
            (scope.row.status === 'Cancel')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_el_tag, {
                    type: "danger",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.status), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true),
            (scope.row.status === 'Rejected')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_el_tag, {
                    type: "error",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        content: scope.row.comment,
                        placement: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(scope.row.status), 1)
                        ]),
                        _: 2
                      }, 1032, ["content"])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "source",
          label: "Source"
        }),
        _createVNode(_component_el_table_column, {
          prop: "address1",
          label: "Address"
        }),
        _createVNode(_component_el_table_column, {
          prop: "tracking",
          label: "Tracking"
        }),
        _createVNode(_component_el_table_column, {
          prop: "sellerAmount",
          label: "FFM Cost"
        })
      ]),
      _: 1
    }, 8, ["data", "lazy"]), [
      [_directive_loading, _ctx.state.isLoading]
    ])
  ]))
}